<section>
  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-lg-9 col-12">
      <!-- Background -->
      <div class="pt-20 rounded-top bg-picture"></div>
      <div class="card rounded-bottom smooth-shadow-sm">
        <div class="d-flex align-items-center justify-content-between pt-4 pb-6 px-4">
          <!-- Avatar -->
          <div class="d-flex align-items-center">
            <div
              class="avatar-xxl avatar-indicators avatar-online me-2 position-relative d-flex justify-content-end align-items-end mt-n10">
              <img src="@/assets/images/user.svg" class="avatar-xxl rounded-circle border border-2" alt="Image">
            </div>
            <!-- Content -->
            <div class="lh-2">
              <h3 class="mb-0 text-secondary">
                {{ companyData?.company_name }}
                <span v-if="membership_name" class="text-primary text-sm ms-2">
                  ({{ membership_name }})
                </span>
              </h3>

              <p class="mb-0 d-block text-xs">
                <span class="text-xs text-secondary">
                  <i class="bx bxs-envelope fs-6"></i>
                </span>
                {{ companyData?.email }}
              </p>
              <p class="mb-0 d-block text-xs">
                <span class="text-xs text-secondary">
                  <i class="bx bxs-phone-call fs-6"></i>
                </span>
                {{ companyData?.tell_number }}
              </p>
              <div class="d-flex flex-wrap gap-3 text-primary small">
                <p class="mb-0 d-block text-xs">
                  <span class="text-xs text-secondary">
                    <i class="bx bxs-map fs-6"></i>
                  </span>
                  {{ companyData?.location }}
                </p>

              </div>
              <div class="rating-container ms-3 mb-2">
                <div class="d-flex align-items-center">
                  <div class="stars me-2">
                    <input type="radio" id="star5" name="rating" :value="5" v-model="rating" @change="saveRating(5)"
                      :disabled="user_id === user_details.user_id" />
                    <label :class="{ checked: rating >= 5 }" for="star5" title="5 stars"></label>

                    <input type="radio" id="star4" name="rating" :value="4" v-model="rating" @change="saveRating(4)"
                      :disabled="user_id === user_details.user_id" />
                    <label :class="{ checked: rating >= 4 }" for="star4" title="4 stars"></label>

                    <input type="radio" id="star3" name="rating" :value="3" v-model="rating" @change="saveRating(3)"
                      :disabled="user_id === user_details.user_id" />
                    <label :class="{ checked: rating >= 3 }" for="star3" title="3 stars"></label>

                    <input type="radio" id="star2" name="rating" :value="2" v-model="rating" @change="saveRating(2)"
                      :disabled="user_id === user_details.user_id" />
                    <label :class="{ checked: rating >= 2 }" for="star2" title="2 stars"></label>

                    <input type="radio" id="star1" name="rating" :value="1" v-model="rating" @change="saveRating(1)"
                      :disabled="user_id === user_details.user_id" />
                    <label :class="{ checked: rating >= 1 }" for="star1" title="1 star"></label>
                  </div>
                  <div class="rating-stats">
                    <span class="rating-value fw-bold me-1">{{ rating }}</span>
                    <span class="rating-count text-muted text-xs">({{ totalRatings }} rated)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <!-- Edit Button -->
            <a v-if="String(companyData?.base_profile?.creater.id) === String(user_details.user_id) " href="#"
              class="btn border-0 text-primary fs-4" @click.prevent="$emit('edit_business_profile', companyData)">
              <i class="bx bxs-edit-alt"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Business Profile Tabs -->
      <div class="bg-light rounded-top shadow-sm px-3 py-2">
        <div class="scrollable-tabs">
          <ul class="nav nav-pills gap-2" id="businessProfileTabs" role="tablist">
            <!-- Static Tabs -->

            <li class="nav-item" role="presentation">
              <button class="nav-link text-xs fw-500 px-4" :class="{ active: activeTab === 'posts' }" id="posts_tab"
                data-bs-toggle="tab" data-bs-target="#posts" type="button" role="tab" aria-controls="posts"
                aria-selected="activeTab === 'posts'" @click="activeTab = 'posts'">
                News & Feeds
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button class="nav-link text-xs fw-500 px-4" :class="{ active: activeTab === 'pitchdeck' }"
                id="pitchdeck_tab" data-bs-toggle="tab" data-bs-target="#pitchdeck" type="button" role="tab"
                aria-controls="pitchdeck" aria-selected="activeTab === 'pitchdeck'" @click="activeTab = 'pitchdeck'">
                Pitchdeck
              </button>
            </li>
            <!-- Dynamic Section Tabs -->
            <li v-for="section in all_section" :key="section.sectionId" class="nav-item" role="presentation">
            <button class="nav-link text-xs fw-500 px-4"
              :class="{ active: activeTab === ('section_' + section.sectionId) }":id="'section_' + section.sectionId + '_tab'" data-bs-toggle="tab" :data-bs-target="'#section_' + section.sectionId" type="button"
              role="tab" :aria-controls="'section_' + section.sectionId" :aria-selected="activeTab === ('section_' + section.sectionId)"@click="on_dynamic_tab_click(section)">
              <span v-if="section.section?.is_locked">
              <i class="bx bx-lock-alt me-1" title="Locked"></i>
            </span>
              {{ section.section?.name }}
            </button>
          </li>
          </ul>
        </div>
      </div>

      <div class="tab-content row mt-3" id="businessProfileTabsContent">



        <div class="tab-pane fade" :class="{ 'show active': activeTab === 'posts' }" id="posts" role="tabpanel"
          aria-labelledby="posts_tab">
          <div v-if="String(companyData?.base_profile?.creater.id) === String(user_details.user_id)">

            <CreateFeed @new_report="addReportToHome" />
          </div>
          <!-- Posts Section -->
          <div class="post-section mt-2 p-3 h-150 full-width-mobile overflow-auto scroll-container padding-x">
            <div v-if="paginatedReports.length">
              <div v-for="report in paginatedReports" :key="report.id"
                class="card shadow card-hover bg-white border-0 mb-4 report-card p-3 rounded-3 d-flex flex-column full-width-mobile"
                :id="'post-' + report.id">
                <div class="row flex-grow-1">
                  <div class="col">
                    <div class="d-flex flex-start">
                      <i class='bx bxs-user-circle text-secondary fs-2'></i>
                      <div class="flex-grow-1 flex-shrink-1">
                        <div>
                          <div class="d-flex justify-content-between align-items-center">
                            <p class="fw-500 mt-1 lh-1 text-xs">
                              <span v-if="report.creater.first_name && report.creater.last_name">{{
                                report.creater.first_name }} {{
                                report.creater.last_name }} </span>
                              <span v-else> {{report.creater.company_name}}</span>
                              <span class="badge bg-warning text-dark mx-2 text-white shadow-sm"><i
                                  class='bx bxs-bulb'></i>{{report.topic_name}}</span><span v-if="report.is_pinned"><i
                                  class='bx bxs-pin'></i></span><br><span class="text-xxs"><i
                                  class="bx bxs-stopwatch"></i> {{ report.publication_date }}</span>
                            </p>
                            <div class="dropstart" @click.stop
                              v-if="String(report.creater.id) === String(user_id) && token_exists ||user_details.user_role=='admin' || portal_admin && token_exists">
                              <a href="" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i class="bi bi-three-dots-vertical"></i><span class="small"></span>
                              </a>
                              <ul class="dropdown-menu custom-dropdown" aria-labelledby="dropdownMenuButton">
                                <li v-if="user_details.user_role === 'admin' || portal_admin"
                                  class="dropdown-item text-xs border-bottom fw-bold" href=""
                                  @click.prevent="togglePinReport(report)">
                                  <i :class="report.is_pinned ? 'bx bx-pin fs-6' : 'bx bxs-pin fs-6'"></i>
                                  {{ report.is_pinned ? 'Unpin' : 'Pin' }}
                                </li>
                                <li>
                                  <a class="dropdown-item text-xs fw-bold" href="" data-bs-toggle="modal"
                                    data-bs-target="#edit_report_modal" @click="edit_report(report)"
                                    v-if="report.total_comments ==0 && report.like_count==0">
                                    <i class="bx bxs-edit fs-6"></i> Edit
                                  </a>
                                </li>
                                <li>
                                  <a class="dropdown-item text-xs fw-bold" href=""
                                    @click.prevent="deleteReport(report.id)">
                                    <i class='bx bxs-trash-alt fs-6'></i> Delete
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="fw-500 text-s">{{ report.name }}<a v-if="report.report_files" :href="report.report_link"
                        class="text-xxs d-block mb-1">
                        <span class="text-dark fw-bold"></span> {{ report.report_link }}</a></p>
                    <div class="text-xs display-6">
                      <span v-html="getDisplayedReportDescription(report)" class="me-1"></span>
                      <!-- 'me-1' adds a small right margin -->
                      <span v-if="shouldShowReadMore(report)" class="text-primary cursor-pointer text-xxs"
                        @click="toggleReportReadMore(report.id)" @click.stop>
                        {{ isReportExpanded(report.id) ? 'Read Less' : 'Read More' }}
                        <i v-if="!isReportExpanded(report.id)" class='bx bx-down-arrow-circle'></i>
                        <i v-else class='bx bx-up-arrow-circle'></i>
                      </span>
                    </div>

                    <div class="d-flex flex-column" v-if="report.report_files && report.report_files.length">
                      <div v-for="(fileObj, index) in report.report_files" :key="index" class="mb-3">
                        <!-- Image -->
                        <img
                          v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                          :src="fileObj.file.file_url" alt="Feed Image" class="img-fluid rounded-3 w-100 h-50"
                          @click="display_comment_modal(report)" />
                        <!-- Audio -->
                        <audio
                          v-else-if="fileObj.file.file_url.includes('.mp3') || fileObj.file.file_url.includes('.wav')"
                          controls class="w-100">
                          <source :src="fileObj.file.file_url" type="audio/mp3">
                          Your browser does not support the audio element.
                        </audio>
                        <!-- Video -->
                        <video v-else-if="fileObj.file.file_url.includes('.mp4')" controls
                          class="img-fluid rounded-3 w-100">
                          <source :src="fileObj.file.file_url" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>
                        <!-- PDF -->
                        <div v-else class="uploaded-file" @click="display_comment_modal(report)">
                          <img :src="getFileIcon(fileObj.file.file_url)" class="file-icon small-icon" />
                          <span class="file-name">{{ getFileName(fileObj.file.file_url) }}</span>
                          <a :href="fileObj.file.file_url" download :title="getFileName(fileObj.file.file_url)"
                            class="download-btn" @click.stop>
                            <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <p v-if="report.is_edited" class="text-muted small text-end">Edited</p>
                    <div class="text-secondary mx-2 mt-1 text-end">

                      <span class="me-2 mt-2">{{ report.like_count || 0 }} <i class='bx bxs-like'></i></span>
                      <span v-if="report.can_comment">{{ report.total_comments }} <i class='bx bxs-comment'></i></span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center border-top">
                      <div class="mb-3 ms-2 me-3 mt-1">
                        <span class="d-flex text-secondary" :id="'like-button' + report.id"
                          @click.stop="likeReport(report)"><i class="bi bi-hand-thumbs-up fw-bold"></i><span
                            class="text-secondary text-xs mt-1 mx-1">Like</span></span>
                        <span :id="'liked-button' + report.id" class="d-none d-flex text-primary"
                          @click.stop="unlikeReport(report)"><i class="bi bi-hand-thumbs-up-fill"></i><span
                            class="text-primary text-xs mt-1 mx-1">Unlike</span></span>
                      </div>
                      <span v-if="hasSupportedFile(report.report_files) && workbook_domain"
                        class="mb-3 ai-agent me-2 mt-2 " type="button" data-bs-toggle="offcanvas"
                        data-bs-target="#sprint_offcanvas" aria-controls="offcanvasTop" @click.stop
                        @click="open_agent(report)">
                        <span>
                          <img class="ai-agent-icon cursor-pointer" src="@/assets/images/ai_loading.gif"
                            alt="Summary" />
                        </span>
                      </span>
                      <div class="input-group mb-3 me-2 rounded-3 w-100 mt-1" @click="display_comment_modal(report)">
                        <input type="text" class="form-control text-xs rounded-start rounded-end"
                          :placeholder="report.can_comment ? 'Write a comment ..' : 'Comments switched off.'"
                          :readonly="!report.can_comment" />
                      </div>
                      <div class="mb-3 me-2 menu mt-1" @click.stop>
                        <input type="checkbox" :id="'menu-open-' + report.id" class="menu-open" name="menu-open" />
                        <span><label :for="'menu-open-' + report.id"
                            class="menu-open-button text-xs text-secondary d-flex" @click="boon"><i
                              class="bi bi-share"></i><span class="text-secondary mx-1">Share</span></label></span>
                        <a @click="copyReportLinkToClipboard(report)" class="menu-item">
                          <span @click="closeMenu(report.id)"><i
                              class="bi bi-link fs-4 copy text-primary text-xxs"></i></span>
                        </a>
                        <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item facebook-share-btn" @click="closeMenu(report.id)">
                          <i class="bi bi-facebook"></i>
                        </a>
                        <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item twitter-share-btn" @click="closeMenu(report.id)">
                          <i class="bi bi-twitter-x"></i>
                        </a>
                        <a :href="'mailto:?subject=Check%20this%20out&body=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item gmail-share-btn" @click="closeMenu(report.id)">
                          <i class="bi bi-google"></i>
                        </a>
                        <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item linkedin-share-btn" @click="closeMenu(report.id)">
                          <i class="bi bi-linkedin"></i>
                        </a>
                        <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item whatsapp-share-btn" @click="closeMenu(report.id)">
                          <i class="bi bi-whatsapp"></i>
                        </a>
                        <a :href="'https://t.me/share/url?url=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item telegram-share-btn" @click="closeMenu(report.id)">
                          <i class="bi bi-telegram"></i>
                        </a>
                        <!-- toaster -->
                        <div aria-live="polite" aria-atomic="true" class="position-fixed custom-toast">
                          <div id="copyToast" class="toast align-items-center text-bg-success border-0" role="alert"
                            aria-live="assertive" aria-atomic="true">
                            <div class="d-flex">
                              <div class="toast-body">
                                Link copied to clipboard!
                              </div>
                              <button type="button" class="btn-close btn-close-white me-2 m-auto"
                                data-bs-dismiss="toast" aria-label="Close"></button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="hasMoreReports" @click="loadMoreReports" class="text-center cursor-pointer text-primary mt-3">
                <span>Load More</span>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="pitchdeck" role="tabpanel" aria-labelledby="pitchdeck_tab">
          <button v-if="String(companyData?.base_profile?.creater.id)===String(user_details.user_id)"
            class="fab border-0 shadow mb-2 ms-3" data-bs-toggle="modal" data-bs-target="#pitchdeck_modal"
            data-bs-dismiss="offcanvas">+</button>

          <div v-if="pitchdecks.length">
            <div class="post_section  p-3 h-100 full-width-mobile overflow-auto scroll-container padding-x">
              <div v-for="item in pitchdecks" :key="item.id"
                class="card shadow card-hover bg-white border-0 mb-4 pitchdeck-card p-3 rounded-3 d-flex flex-row col-md-12 full-width-mobile">
                <!-- Summary Section -->
                <div class="col-md-6">
                  <span v-html="item.summary"></span>
                  <p v-if="item.picth_deck_files?.[0]?.date" class="text-xs text-muted">{{ item.picth_deck_files[0].date
                    }}</p>
                </div>
                <div class="dropstart position-absolute top-0 end-0 m-2">
                  <a href="#" class="text-dark" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="bi bi-three-dots-vertical"></i>
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item text-xs" href="#" @click="open_edit_pitchdeck_modal(item)">Edit</a>
                    </li>
                    <li>
                      <a class="dropdown-item text-xs text-danger" href="#"
                        @click="delete_pitch_deck(item.id)">Delete</a>
                    </li>
                  </ul>
                </div>
                <!-- File Section -->
                <div class="col-md-6 h-100 mt-5" v-if="item.picth_deck_files && item.picth_deck_files.length">
                  <div v-for="(fileObj, index) in item.picth_deck_files" :key="index" class="mb-3 h-100">
                    <!-- Image -->
                    <img
                      v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                      :src="fileObj.file.file_url" alt="Pitchdeck Image" class="img-fluid rounded-3 w-100 h-50" />
                    <!-- Video -->
                    <video v-else-if="fileObj.file.file_url.includes('.mp4')" controls
                      class="img-fluid rounded-3 w-100">
                      <source :src="fileObj.file.file_url" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    <!-- PDF -->
                    <iframe v-else-if="fileObj.file.file_url.includes('.pdf')"
                      :src="'https://docs.google.com/viewer?url=' + encodeURIComponent(fileObj.file.file_url) + '&embedded=true'"
                      frameborder="0" width="100%" height="500px"></iframe>
                    <!-- PowerPoint -->
                    <iframe
                      v-else-if="fileObj.file.file_url.includes('.ppt') || fileObj.file.file_url.includes('.pptx')"
                      :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                      frameborder="0" width="100%" height="500px"></iframe>
                    <!-- Word Document -->
                    <iframe
                      v-else-if="fileObj.file.file_url.includes('.doc') || fileObj.file.file_url.includes('.docx')"
                      :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                      frameborder="0" width="100%" height="500px"></iframe>
                    <!-- Excel Document -->
                    <iframe
                      v-else-if="fileObj.file.file_url.includes('.xls') || fileObj.file.file_url.includes('.xlsx') || fileObj.file.file_url.includes('.csv')"
                      :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                      frameborder="0" width="100%" height="500px"></iframe>
                    <!-- Other File Types -->
                    <div v-else>
                      <a :href="fileObj.file.file_url" target="_blank"
                        class="btn btn-primary text-xs rounded-3">Download File</a>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 text-center text-muted" v-else>
                  <p class="text-xs">No files available for this pitch deck.</p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center text-muted py-5">
            <i class="bx bx-file fs-1"></i>
            <p class="mb-0 mt-2">No pitchdeck items available</p>
          </div>
        </div>

        <!-- Replace your current tab-pane v-for for forms with this section-based one: -->
<div v-for="section in all_section" :key="'section_' + section.sectionId + '_pane'" class="tab-pane fade"
  :class="{ 'show active': activeTab === ('section_' + section.sectionId) }"
  :id="'section_' + section.sectionId"
  role="tabpanel"
  :aria-labelledby="'section_' + section.sectionId + '_tab'">

  <!-- 🔒 Locked section: Non-creator without access -->
  <div v-if="section.section?.is_locked && String(companyData?.base_profile?.creater.id) !== String(user_details.user_id) && !section.access_approved">
    <div class="text-center text-muted py-5">
      <i class="bx bx-lock fs-1"></i>
      <p class="mb-2 mt-2">
        <span v-if="!section.access_requested">You do not have access to view this section.</span>
        <span v-else>You have already requested access. Waiting for approval.</span>
      </p>
      <!-- Request Access button -->
      <button v-if="!section.access_requested" class="btn btn-primary rounded-3"
        @click="request_tab_access(section)">
        Request Access
      </button>
    </div>
  </div>

  <!-- ✅ Approved or creator sees this -->
  <div v-else>
    <!-- 🔁 Pending notice -->
    <div v-if="section.access_requested && !section.access_approved && String(companyData?.base_profile?.creater.id) !== String(user_details.user_id)"
      class="text-center text-primary py-5">
      <i class="bx bx-time-five fs-1"></i>
      <p class="mb-0 mt-2">
        You have already requested access. Waiting for approval.
      </p>
    </div>

    <div v-else>
      <div class="row align-items-start">
        <div :class="section.section?.is_locked && String(companyData?.base_profile?.creater.id) === String(user_details.user_id) ? 'col-md-9 col-12' : 'col-12'">
          <div class="p-3 bg-white rounded shadow-sm border">
            <h5 class="fw-bold text-secondary mb-5">
              {{ section.section?.name }} Information
            </h5>

            <div v-if="section.section?.question_sections?.length">
              <div v-for="(qa, index) in section.section.question_sections" :key="'qa_' + qa.id" class="mb-3">
                <div class="row align-items-start">
                  <!-- Question with pencil -->
                  <div class="col-sm-4 fw-bold text-xs d-flex align-items-center justify-content-between">
                    {{ qa.question?.question || 'Untitled Question' }}
                    <i v-if="String(companyData?.base_profile?.creater.id) === String(user_details.user_id)"
                      class="bx bxs-pencil text-primary text-muted ms-2 cursor-pointer"
                      @click="qa.isEditing = !qa.isEditing" title="Edit Answer"></i>
                  </div>
                  <!-- Answer -->
                  <div class="col-sm-8 text-dark text-xs">
                    <!-- Edit Mode -->
                    <div v-if="qa.isEditing" >
                      <input v-if="qa.question.question_type.question_type === 'text'" v-model="qa.newAnswer"
                        type="text" class="form-control form-control-sm rounded-3 w-75 shadow-sm border-0 mb-2" />
                      <textarea v-else-if="qa.question.question_type.question_type === 'textarea'"
                        v-model="qa.newAnswer" class="form-control form-control-sm rounded-3 mb-2"></textarea>
                      <input v-else-if="qa.question.question_type.question_type === 'date'"
                        v-model="qa.newAnswer" type="date"
                        class="form-control form-control-sm rounded-3 w-50 mb-2" />
                      <input v-else-if="qa.question.question_type.question_type === 'number'"
                        v-model="qa.newAnswer" type="number"
                        class="form-control form-control-sm rounded-3 w-50 mb-2" />
                      <select v-else-if="qa.question.question_type.question_type === 'selection'"
                        v-model="qa.newAnswer" class="form-control form-control-sm rounded-3 w-75 mb-2">
                        <option v-for="opt in qa.question.options" :key="opt.id" :value="opt.option">
                          {{ opt.option }}
                        </option>
                      </select>
                      <div v-else-if="qa.question.question_type.question_type === 'multiple_choice'" class="mb-2">
                        <div v-for="opt in qa.question.options" :key="opt.id" class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" :id="'radio_' + qa.id + '_' + opt.id"
                            :value="opt.option" v-model="qa.newAnswer" />
                          <label class="form-check-label text-xs" :for="'radio_' + qa.id + '_' + opt.id">
                            {{ opt.option }}
                          </label>
                        </div>
                      </div>
                      <div v-else-if="qa.question.question_type.question_type === 'checkbox'" class="mb-2">
                        <div v-for="opt in qa.question.options" :key="opt.id" class="form-check form-check-inline">
                          <input type="checkbox" class="form-check-input" :id="'cb_' + qa.id + '_' + opt.id"
                            :value="opt.option" :checked="qa.newAnswer?.includes(opt.option)"
                            @change="toggleCheckbox(qa, opt.option, $event.target.checked)" />
                          <label class="form-check-label text-xs" :for="'cb_' + qa.id + '_' + opt.id">
                            {{ opt.option }}
                          </label>
                        </div>
                      </div>
                      <button class="btn btn-primary btn-sm mt-2 rounded-3 shadow" @click="submitAnswer(qa)">
                        Save
                      </button>
                    </div>
                    <!-- View Mode -->
                    <div v-else>
                      <div v-if="companyData.answers && companyData.answers.find(ans => ans.question.id === qa.question.id)">
                        <div v-if="qa.question.question_type.question_type === 'checkbox' &&
                          companyData.answers.find(ans => ans.question.id === qa.question.id).answer.trim() !== ''">
                          <div v-for="val in companyData.answers.find(ans => ans.question.id === qa.question.id).answer.split(',')" :key="val.trim()">
                            • {{ getOptionValue(val.trim(), qa.question.options) || val.trim() }}
                          </div>
                        </div>
                        <div v-else-if="qa.question.question_type.question_type === 'checkbox'" class="text-muted fst-italic">
                          Not submitted
                        </div>
                        <div v-else>
                          {{
                            companyData.answers.find(ans => ans.question.id === qa.question.id).answer === ''
                            ? 'Not submitted'
                            : (
                              getOptionValue(
                                companyData.answers.find(ans => ans.question.id === qa.question.id).answer,
                                qa.question.options
                              ) || companyData.answers.find(ans => ans.question.id === qa.question.id).answer
                            )
                          }}
                        </div>
                      </div>
                      <div v-else class="text-muted fst-italic">Not submitted</div>
                    </div>
                  </div>
                </div>
                <hr v-if="index < section.section.question_sections.length - 1" class="my-3" />
              </div>
            </div>
            <div v-else class="text-muted fst-italic">No questions available in this section.</div>
          </div>
        </div>
        <!-- Right Panel for Creator -->
        <div v-if="section.section?.is_locked && String(companyData?.base_profile?.creater.id) === String(user_details.user_id)"
          class="col-md-3 col-12">
          <div class="card mb-2">
            <div class="card-header bg-secondary text-white text-xs fw-bold">Pending Requests</div>
            <div class="card-body">
              <div v-for="req in companyData.tab_access_requests.filter(r => String(r.section) === String(section.sectionId) && r.status?.toLowerCase() === 'pending')" :key="'pending_' + req.id"
                class="mb-2 text-xs d-flex align-items-center justify-content-between">
                <div>
                  <i class="bi bi-person-clock me-1 fs-6"></i>
                
                  {{ req.requester?.profile_name || req.requester?.first_name || req.requester }}
                </div>
                <div>
                  <button class="btn btn-success btn-sm rounded-3 me-1"
                    @click="approve_request(req)">Approve</button>
                  <button class="btn btn-danger btn-sm rounded-3" @click="decline_request(req)">Decline</button>
                </div>
              </div>
              <div v-if="!companyData.tab_access_requests.some(r => String(r.section) === String(section.sectionId) && r.status?.toLowerCase() === 'pending')" class="text-muted text-xs">
                No pending requests
              </div>
            </div>
          </div>
          <div class="card border-success mb-2">
            <div class="card-header bg-secondary text-white text-xs fw-bold">Users with Access</div>
            <div class="card-body">
              <div v-for="req in companyData.tab_access_requests.filter(r => String(r.section) === String(section.sectionId) && r.status?.toLowerCase() === 'approved')" :key="'approved_' + req.id" class="mb-1 text-xs">
                <i class="bi bi-person-check me-1 fs-5"></i>
                {{ req.requester?.profile_name || req.requester?.first_name || req.requester }}
              </div>
              <div v-if="!companyData.tab_access_requests.some(r => String(r.section) === String(section.sectionId) && r.status?.toLowerCase() === 'approved')" class="text-muted text-xs">
                No users with access
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


      </div>
    </div>

  </div>
  <div class="modal fade" id="edit_report_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">edit your feed</h5>
          <button type="button" class="btn-close  text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="edit_report_data">
          <div class="modal-body">
            <QuillEditor theme="snow" v-model="report_description" ref="quillReportRef" class="quill-editor"
              toolbar="full" />
            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
              <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
                <label for="editReportFileInput"
                  class="text-xs text-secondary fw-500 border-0 rounded-3 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                  <i class='bx bx-image-add file-upload-icon'></i> Add Feed content
                </label>
                <input type="file" id="editReportFileInput" class="file-input d-none"
                  @change="handleHomeFilterFileUpload" />
                <div v-if="editFileName" class="text-xs text-secondary fst-italic mt-1">
                  <span class="fw-500">File name:</span> {{ editFileName }}
                </div>
                <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>
              </div>
              <div class="file-upload ms-5 my-2 mx-3 flex-grow-1 d-flex flex-column align-items-center">
                <label for="audioInput"
                  class="text-xs text-secondary fw-500 border-0 rounded-3 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                  <i class='bx bx-music'></i> Upload Audio
                </label>
                <input type="file" accept="audio/*" id="audioInput" class="file-input d-none"
                  @change="handleAudioUpload" />
                <div v-if="audioError" class="text-xs text-danger fst-italic mt-1">{{ audioError }}</div>
              </div>
              <div class="d-flex flex-column align-items-center my-2 flex-grow-1">
                <div class="d-flex flex-row align-items-center mb-3">
                  <button type="button"
                    class="btn btn-primary text-xs rounded-3 mx-2 d-flex align-items-center justify-content-center"
                    @click="startRecording" v-if="!isRecording">
                    <i class='bx bx-microphone'></i> Record
                  </button>
                  <button type="button"
                    class="btn btn-danger text-xs rounded-3 mx-2 d-flex align-items-center justify-content-center"
                    @click="stopRecording" v-if="isRecording">
                    <i class='bx bx-stop'></i> Stop
                  </button>
                </div>
                <div v-if="audio_file_name" class="text-xs text-secondary fw-500 mb-3 audio-file">
                  <i class='bx bx-music'></i> Recorded: {{ audio_file_name }}
                </div>
              </div>
            </div>
            <div class="d-flex flex-column" v-if="edit_documents.report_files && edit_documents.report_files.length">
              <div class="row g-3">
                <div v-for="(fileObj, index) in edit_documents.report_files" :key="index" class="col-4  mb-3">

                  <!-- Image -->
                  <img
                    v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                    :src="fileObj.file.file_url" alt="Feed Image" class="img-fluid rounded-3 w-100 h-50"
                    :class="{ 'zoomed-in': isZoomed }" @click="display_comment_modal(report)" ref="image" />

                  <!-- Audio -->
                  <audio v-else-if="fileObj.file.file_url.includes('.mp3') || fileObj.file.file_url.includes('.wav')"
                    controls class="w-100 rounded-3">
                    <source :src="fileObj.file.file_url" type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>

                  <!-- Video -->
                  <video v-else-if="fileObj.file.file_url.includes('.mp4')" controls class="img-fluid rounded-3 w-100">
                    <source :src="fileObj.file.file_url" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>

                  <!-- PDF -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.pdf')"
                    :src="'https://docs.google.com/viewer?url=' + encodeURIComponent(fileObj.file.file_url) + '&embedded=true'"
                    frameborder="0" width="100%" height="500px">
                  </iframe>

                  <!-- Word Document -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.docx') || fileObj.file.file_url.includes('.doc')"
                    :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                    class="img-fluid rounded-3 w-100">
                  </iframe>

                  <!-- Excel Document -->
                  <iframe v-else-if="fileObj.file.file_url.includes('.xls') ||
                                      fileObj.file.file_url.includes('.xlsx') ||
                                      fileObj.file.file_url.includes('.xlsm') ||
                                      fileObj.file.file_url.includes('.xlsb')"
                    :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                    frameborder="0" width="100%" height="500px">
                  </iframe>

                  <!-- Zoom Button -->
                  <button v-if="!fileObj.file.file_url.includes('.mp3') &&
                                !fileObj.file.file_url.includes('.wav')" @click="toggleZoom"
                    class="zoom-btn btn btn-light position-absolute top-0 end-0 m-2 bg-transparent rounded-3">
                    <i :class="isZoomed ? 'bx bxs-zoom-out fs-5 text-white' : 'bx bxs-zoom-in fs-5 text-white'"></i>
                  </button>

                  <!-- Fullscreen Button -->
                  <button v-if="!fileObj.file.file_url.includes('.mp3') &&
                                !fileObj.file.file_url.includes('.wav')" @click="toggleFullscreen"
                    class="fullscreen-btn position-absolute btn btn-light top-0 start-0 m-2">
                    <i class="bi bi-arrows-fullscreen"></i>
                  </button>

                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-3">Post</button>
          </div>
        </form>
      </div>
    </div>
  </div>


  <div class="modal fade" id="add_team_modal" tabindex="-1" aria-labelledby="addMemberModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content rounded-3">
        <div class="modal-header">
          <h5 class="modal-title" id="addMemberModalLabel">
            {{ edit_member_id ? 'Edit Team Member' : 'Add Team Member' }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="edit_member_id ? update_member() : add_member()">
            <div class="mb-3">
              <label for="member_name" class="form-label text-xs fw-500">First Name</label>
              <input type="text" id="member_name" v-model="first_name" class="form-control rounded-3 text-xs"
                placeholder="Enter first name">
              <p v-if="errors.first_name" class="text-danger text-xs">{{ errors.first_name }}</p>
            </div>
            <div class="mb-3">
              <label for="member_last" class="form-label text-xs fw-500">Last Name</label>
              <input type="text" id="member_last" v-model="last_name" class="form-control rounded-3 text-xs"
                placeholder="Enter last name">
              <p v-if="errors.last_name" class="text-danger text-xs">{{ errors.last_name }}</p>
            </div>
            <div class="mb-3">
              <label for="member_email" class="form-label text-xs fw-500">Email</label>
              <input type="email" id="member_email" v-model="email" class="form-control rounded-3 text-xs"
                placeholder="Enter email address">
              <p v-if="errors.email" class="text-danger text-xs">{{ errors.email }}</p>
            </div>
            <div class="mb-3">
              <label for="member_role" class="form-label text-xs fw-500">Role</label>
              <input type="text" id="member_role" v-model="member_role" class="form-control rounded-3 text-xs"
                placeholder="Enter member role">
              <p v-if="errors.role" class="text-danger text-xs">{{ errors.role }}</p>
            </div>
            <div class="text-end">
              <button type="submit" class="btn btn-primary text-xs rounded-3 shadow">
                {{ edit_member_id ? 'Update Member' : 'Add Member' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="pitchdeck_modal" tabindex="-1" aria-labelledby="documentApprovalModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500"> {{ edit_pitchdeck_id ? 'Edit Pitch Deck' : 'Upload Pitch deck' }}</p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="edit_pitchdeck_id ? update_pitchdeck() : create_pitchdeck()">
          <div class="modal-body modal-body-scroll">

            <!-- Document Review Section (Editor or Description) -->
            <QuillEditor theme="snow" v-model="pitch_description" ref="quillPitchdeckEditorRef" class="quill-editor"
              placeholder="Enter your summary here..." toolbar="full" />

            <!-- File Upload for Document -->
            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start border-bottom">
              <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
                <label for="pitchFileInput"
                  class="text-xs text-secondary fw-500 border-0 rounded-3 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                  <i class='bx bx-image-add file-upload-icon'></i> Upload Document/Media
                </label>
                <input type="file" id="pitchFileInput" class="file-input d-none" @change="handle_pitch_file_upload" />
                <div v-if="fileName" class="text-xs text-secondary fst-italic mt-1">
                  <span class="fw-500">File name:</span> {{ fileName }}
                </div>
                <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>

                <!-- Image or Document Preview -->
                <div v-if="filePreview" class="mt-2">
                  <a :href="filePreview" target="_blank" class="text-xs text-primary">Preview Document</a>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-3">
              {{ edit_pitchdeck_id ? 'Update' : 'Upload' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Place this after your last modal (e.g. after #company_finance_modal or at the end of your file, but inside <section>) -->

  <teleport to="body">
    <div v-for="section in questions" :key="'dynamic_section_modal_' + section.form?.form_sections?.[0]?.section?.id"
      class="modal fade" :id="'dynamic_section_modal_' + section.form?.form_sections?.[0]?.section?.id" tabindex="-1"
      aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content rounded-3">
          <div class="modal-header">
            <h5 class="modal-title">
              Add {{ section.form?.form_sections?.[0]?.section?.name }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent="submitAnswer(section)">
            <div class="modal-body">
              <div v-if="section.form?.form_sections?.length">
                <div v-for="(form_section, section_index) in section.form.form_sections"
                  :key="'section_' + section_index" class="mb-4 border rounded p-3 position-relative">
                  <span
                    class="px-2 py-1 bg-white position-absolute top-0 start-0 translate-middle-y ms-3 text-muted small fw-semibold">
                    {{ form_section?.section?.name }}
                  </span>
                  <div v-for="(question_section, question_index) in form_section?.section?.question_sections"
                    :key="'question_' + question_section.question.id" class="mb-3 border rounded p-3 bg-light">
                    <label :for="'question_' + question_section.question.id" class="form-label fw-500">
                      {{ question_section.question.question }}
                      <span v-if="question_section.question.is_mandatory" class="text-danger">*</span>
                    </label>
                    <!-- Text input -->
                    <input v-if="question_section.question.question_type.question_type === 'text'" type="text"
                      class="form-control text-xs rounded-3" :id="'question_' + question_section.question.id"
                      :placeholder="question_section.question.question" v-model="question_section.answer" />
                    <!-- Selection dropdown -->
                    <select v-else-if="question_section.question.question_type.question_type === 'selection'"
                      class="form-control text-xs rounded-3 w-25" :id="'question_' + question_section.question.id"
                      v-model="question_section.answer">
                      <option value="" disabled>Select an option</option>
                      <option v-for="option in question_section.question.options" :key="option.id"
                        :value="option.option">
                        {{ option.option }}
                      </option>
                    </select>
                    <!-- Yes/No Radio Buttons -->
                    <div v-else-if="question_section.question.question_type.question_type === 'yes_no'"
                      class="form-check form-check-inline">
                      <input type="radio" class="form-check-input" :id="'yes_' + question_section.question.id"
                        :name="'question_' + question_section.question.id" value="Yes"
                        v-model="question_section.answer" />
                      <label class="form-check-label" :for="'yes_' + question_section.question.id">Yes</label>
                      <input type="radio" class="form-check-input ms-3" :id="'no_' + question_section.question.id"
                        :name="'question_' + question_section.question.id" value="No"
                        v-model="question_section.answer" />
                      <label class="form-check-label" :for="'no_' + question_section.question.id">No</label>
                    </div>
                    <!-- Multiple Choice (radio) -->
                    <div v-else-if="question_section.question.question_type.question_type === 'multiple_choice'"
                      class="form-check">
                      <div v-for="option in question_section.question.options" :key="option.id" class="form-check">
                        <input type="radio" class="form-check-input" :id="'option_' + option.id"
                          :name="'question_' + question_section.question.id" :value="option.option"
                          v-model="question_section.answer" />
                        <label class="form-check-label" :for="'option_' + option.id">
                          {{ option.option }}
                        </label>
                      </div>
                    </div>
                    <!-- Checkbox (multi-select) -->
                    <div v-else-if="question_section.question.question_type.question_type === 'checkbox'"
                      class="form-check">
                      <div v-for="option in question_section.question.options" :key="option.id" class="form-check">
                        <input type="checkbox" class="form-check-input" :id="'checkbox_' + option.id"
                          :value="option.option" :checked="question_section.answer?.includes(option.option)"
                          @change="toggle_checkbox_answer(question_section, option.option, $event.target.checked)" />
                        <label class="form-check-label" :for="'checkbox_' + option.id">
                          {{ option.option }}
                        </label>
                      </div>
                    </div>
                    <!-- Number Input -->
                    <input v-else-if="question_section.question.question_type.question_type === 'number'" type="number"
                      class="form-control text-xs rounded-3 w-25" :id="'question_' + question_section.question.id"
                      v-model="question_section.answer" />
                    <!-- Date Input -->
                    <input v-else-if="question_section.question.question_type.question_type === 'date'" type="date"
                      class="form-control text-xs rounded-3 w-25" :id="'question_' + question_section.question.id"
                      v-model="question_section.answer" />
                    <!-- File Input -->
                    <input v-else-if="question_section.question.question_type.question_type === 'file'" type="file"
                      class="form-control text-xs rounded-3 w-25" :id="'question_' + question_section.question.id"
                      @change="handle_file_upload($event, question_section)" />
                    <!-- Error message -->
                    <p v-if="errors['question_' + question_section.question.id]" class="text-danger text-xs">
                      {{ errors['question_' + question_section.question.id] }}
                    </p>
                  </div>
                </div>
              </div>
              <div v-else class="text-muted text-xs">No questions available for this section.</div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary text-xs rounded-3">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>
</section>
<ReportCommentModal v-if="comment_modal_visible" :report_data="report_data"
  @hide_comment_comment="hide_comment_comment" />